(() => {
  if (window.cardMobileGalleryInitialised) return;
  window.cardMobileGalleryInitialised = true;

  const GALLERY_SELECTOR = '[data-card-mobile-gallery]';
  const TRACK_SELECTOR = '[data-card-mobile-gallery-track]';
  const SLIDE_SELECTOR = '[data-card-mobile-gallery-slide]';
  const DOT_SELECTOR = '[data-card-mobile-gallery-dot]';

  const touchStates = new WeakMap();
  const animationFrames = new WeakMap();

  const getTrack = (gallery) => {
    return gallery.querySelector(TRACK_SELECTOR);
  };

  const getSlides = (track) => {
    return Array.from(track.querySelectorAll(SLIDE_SELECTOR));
  };

  const getCurrentIndex = (track) => {
    if (!track.clientWidth) return 0;

    return Math.round(track.scrollLeft / track.clientWidth);
  };

  const updateControls = (gallery) => {
    const track = getTrack(gallery);
    if (!track) return;

    const slides = getSlides(track);
    const currentIndex = Math.min(
      Math.max(getCurrentIndex(track), 0),
      slides.length - 1
    );

    const previousButton = gallery.querySelector(
      '[data-card-mobile-gallery-prev]'
    );

    const nextButton = gallery.querySelector(
      '[data-card-mobile-gallery-next]'
    );

    if (previousButton) {
      previousButton.disabled = currentIndex === 0;
    }

    if (nextButton) {
      nextButton.disabled = currentIndex === slides.length - 1;
    }

    gallery.querySelectorAll(DOT_SELECTOR).forEach((dot, index) => {
      const isActive = index === currentIndex;

      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const goToSlide = (gallery, requestedIndex) => {
    const track = getTrack(gallery);
    if (!track || !track.clientWidth) return;

    const slides = getSlides(track);

    const safeIndex = Math.min(
      Math.max(requestedIndex, 0),
      slides.length - 1
    );

    track.scrollTo({
      left: safeIndex * track.clientWidth,
      behavior: 'smooth',
    });

    window.setTimeout(() => {
      updateControls(gallery);
    }, 350);
  };

  /*
   * Flechas y puntos.
   */
  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest?.(
        '[data-card-mobile-gallery-prev], ' +
          '[data-card-mobile-gallery-next], ' +
          '[data-card-mobile-gallery-dot]'
      );

      if (control) {
        const gallery = control.closest(GALLERY_SELECTOR);
        if (!gallery) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const track = getTrack(gallery);
        const currentIndex = getCurrentIndex(track);

        if (control.matches('[data-card-mobile-gallery-prev]')) {
          goToSlide(gallery, currentIndex - 1);
          return;
        }

        if (control.matches('[data-card-mobile-gallery-next]')) {
          goToSlide(gallery, currentIndex + 1);
          return;
        }

        goToSlide(
          gallery,
          Number(control.dataset.cardMobileGalleryDot)
        );

        return;
      }

      /*
       * Un toque normal sobre la imagen abre el producto.
       * Si el usuario acaba de arrastrar, no abre la ficha.
       */
      const gallery = event.target.closest?.(GALLERY_SELECTOR);
      if (!gallery) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (gallery.dataset.preventOpen === 'true') {
        gallery.dataset.preventOpen = 'false';
        return;
      }

      const productUrl = gallery.dataset.productUrl;

      if (productUrl) {
        window.location.assign(productUrl);
      }
    },
    true
  );

  /*
   * Detecta un desplazamiento horizontal para impedir que
   * un swipe termine abriendo accidentalmente el producto.
   */
  document.addEventListener(
    'touchstart',
    (event) => {
      const track = event.target.closest?.(TRACK_SELECTOR);
      const touch = event.touches?.[0];

      if (!track || !touch) return;

      const gallery = track.closest(GALLERY_SELECTOR);

      touchStates.set(track, {
        startX: touch.clientX,
        startY: touch.clientY,
      });

      if (gallery) {
        gallery.dataset.preventOpen = 'false';
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      const track = event.target.closest?.(TRACK_SELECTOR);
      const touch = event.touches?.[0];

      if (!track || !touch) return;

      const state = touchStates.get(track);
      if (!state) return;

      const deltaX = touch.clientX - state.startX;
      const deltaY = touch.clientY - state.startY;

      if (
        Math.abs(deltaX) > 8 &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        const gallery = track.closest(GALLERY_SELECTOR);

        if (gallery) {
          gallery.dataset.preventOpen = 'true';
        }
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const track = event.target.closest?.(TRACK_SELECTOR);
      if (!track) return;

      touchStates.delete(track);

      const gallery = track.closest(GALLERY_SELECTOR);

      if (gallery?.dataset.preventOpen === 'true') {
        window.setTimeout(() => {
          gallery.dataset.preventOpen = 'false';
        }, 500);
      }
    },
    { passive: true, capture: true }
  );

  /*
   * Actualiza flechas y puntos durante un swipe nativo.
   */
  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target.closest?.(TRACK_SELECTOR);
      if (!track) return;

      const gallery = track.closest(GALLERY_SELECTOR);
      if (!gallery) return;

      const previousFrame = animationFrames.get(track);

      if (previousFrame) {
        window.cancelAnimationFrame(previousFrame);
      }

      const nextFrame = window.requestAnimationFrame(() => {
        updateControls(gallery);
      });

      animationFrames.set(track, nextFrame);
    },
    true
  );

  const initialiseGalleries = () => {
    document
      .querySelectorAll(GALLERY_SELECTOR)
      .forEach(updateControls);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseGalleries
    );
  } else {
    initialiseGalleries();
  }

  /*
   * Shopify puede redibujar la parrilla al filtrar productos.
   */
  const observer = new MutationObserver(() => {
    initialiseGalleries();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();